var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var DesirableDirection = /* @__PURE__ */ ((DesirableDirection2) => {
  DesirableDirection2["Neutral"] = "Neutral";
  DesirableDirection2["Up"] = "Up";
  DesirableDirection2["Down"] = "Down";
  return DesirableDirection2;
})(DesirableDirection || {});
class MetricSignificance {
  constructor() {
    __publicField(this, "HSSPosCount", 0);
    __publicField(this, "SSPosCount", 0);
    __publicField(this, "HSSNegCount", 0);
    __publicField(this, "SSNegCount", 0);
    __publicField(this, "HSSNeutCount", 0);
    __publicField(this, "SSNeutCount", 0);
    __publicField(this, "TotalCount", 0);
  }
}
export {
  DesirableDirection,
  MetricSignificance
};
//# sourceMappingURL=GarModel.js.map
